import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';

import { Size } from '../../types';
import { Icon, IconName } from '../../atoms/icons/';

export interface Props {
  className?: string;
  icon: IconName;
  size?: Size;
  text: string;
}

class InlineIconText extends React.Component<Props, any> {
  static defaultProps: Props = {
    size: 'md',
    icon: 'bullseye',
    text: '',
  };

  public render() {
    const { className, icon, size, text } = this.props;
    return (
      <div className={className}>
        <Icon icon={icon} size={size} />
        <span>{text}</span>
      </div>
    );
  }
}

export default styled(InlineIconText)`
  display: flex;
  align-items: center;

  svg {
    margin-right: 0.5rem;
  }
`;
